import React, { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import Header from "../components/Header";
import Footer from "../containers/Footer";

const Contact = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // validation
    if(!formData.name || !formData.email || !formData.subject || !formData.message){
      alert("Please fill in all fields.");
      return;
    }

    const emailRegex = /\S+@\S+\.\S+/;
    if(!emailRegex.test(formData.email)){
      alert("Invalid email format.");
      return;
    }

    alert("Thank you for contacting us! We will get back to you soon.");

    // here you can call API for storing data or sending email...
  };

  return (
    <>

        <Header />
      <header className="bg-primary text-white text-center py-5" style={{marginTop:"70px"}}>
        <h1>Contact Us</h1>
      </header>

      <div className="container my-5">
        <div className="card p-4 shadow-sm">
          <h2 className="text-primary mb-4">Send Us a Message</h2>

          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Your Name</label>
              <input
                type="text"
                className="form-control"
                name="name"
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Your Email</label>
              <input
                type="email"
                className="form-control"
                name="email"
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Subject</label>
              <input
                type="text"
                className="form-control"
                name="subject"
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Your Message</label>
              <textarea
                className="form-control"
                rows="5"
                name="message"
                onChange={handleChange}
                required
              ></textarea>
            </div>

            <button className="btn btn-primary px-4" type="submit">
              Submit
            </button>
          </form>

          <div className="mt-5">
            <h3>Other Ways to Reach Us</h3>
            <p><strong>Email:</strong> <a href="mailto:support@resumepilot.com">support@resumesnap.com</a></p>
            <p><strong>Phone:</strong> +91 9999999999</p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
 